import ProfileBuilder from "./profile-builder";
import Academics from "./academics";
import Activities from "./activities";
import Address from "./address";
import ContactProfileBuilder from "./contacts";
import Counselor from "./counselor";
import Demographics from "./demographics";
import Education from "./education";
import Facilities from "./facilities";
import Financial from "./financial";
import GeneralInfo from "./general-info";
import Location from "./location";
import Others from "./others";
import HighSchoolGrades from "./high-school-grades";
import People from "./people";
import TestScores from "./test-scores";

export default {
  ProfileBuilder,
  Academics,
  Activities,
  Address,
  ContactProfileBuilder,
  Counselor,
  Demographics,
  Education,
  Facilities,
  Financial,
  GeneralInfo,
  Location,
  Others,
  HighSchoolGrades,
  People,
  TestScores,
};
